import React from "react";
import AllProductsGrid from "./components/AllProductsGrid";

const allProducts = [
  {
    id: "m1",
    name: "Yeşil Bubble Kase",
    image: "/images/Ekran Resmi 2025-11-03 ÖS 6.20.46.png",
    description: "Bu yeşil tonlarındaki el yapımı bubble kase, yumuşak dokusu ve eşsiz desenleriyle dikkat çeker. Kase, sade bir tasarıma sahip olmasına rağmen, her ortamda şık bir dokunuş sağlar. Hem dekoratif hem de fonksiyonel olarak kullanılabilecek harika bir üründür. 15x10 boyutlarında ve bubble tekniği uygulanarak yapılmıştır. el yapımıdır.",
    category: "Kupa"
  },
  {
    id: "m2",
    name: "Seramik Kupa 2",
    image: "/images/mug-image-2.png",
    description: "Koyu sır ile işlenmiş zarif seramik kupa.",
    category: "Kupa"
  },
  {
    id: "m3",
    name: "Seramik Kupa 3",
    image: "/images/mug-image-3.png",
    description: "Mat ve dokulu yüzeye sahip modern kupa.",
    category: "Kupa"
  },
  {
    id: "v1",
    name: "El Yapımı Vazo 1",
    image: "/images/vase-image-1.png",
    description: "Modern çizgilerle tasarlanmış dekoratif vazo.",
    category: "Vazo"
  },
  {
    id: "v2",
    name: "El Yapımı Vazo 2",
    image: "/images/vase-image-2.png",
    description: "Mat yüzeyli, minimalist seramik vazo.",
    category: "Vazo"
  },
  {
    id: "v3",
    name: "El Yapımı Vazo 3",
    image: "/images/vase-image-3.png",
    description: "Koyu tonlarda, dokulu artistik seramik vazo.",
    category: "Vazo"
  }
];

const AllProductsPage = () => {
  return (
    <div href="all-products" className="min-h-screen bg-white">
      <AllProductsGrid products={allProducts} />
    </div>
  );
};

export default AllProductsPage;
